module.exports = __webpack_public_path__ + "media/ppc/military_background_ppc-5d554578.jpg";